<template>
  <div class="page-wrapper"  style="position: fixed; top:0; left:0; width: 100%; height: 100%; padding-top:0; color: #555;">
    <div style="width: 100%;  height: 50px; display: flex;" v-if="merchantItem !== false">
      <div style="width: 50%; height: 50px; line-height: 50px; vertical-align: top;">
        <span v-if="merchantItem.webSetting !== undefined && merchantItem.webSetting !== null && merchantItem.webSetting.icon !== null && merchantItem.webSetting.icon.length > 0"><img :src="merchantItem.webSetting.icon" height="40px;"></span>
        <span style="font-size: 20px; font-weight: bold;">{{merchantItem.title}}</span>
      </div>
      <div style="width: 50%; height: 50px; line-height: 50px; text-align: right; padding-right: 10px;">
        <span v-if="merchantItem.contact.length > 0">TEL: {{merchantItem.contact}}</span>
      </div>
    </div>
    <div style="height: calc(100% - 150px); width: 100%; position: relative; overflow: hidden;" v-if="merchantItem !== false">
      <menu-view
        :merchant="merchantItem"
        :show-top="false"
        :type="'dineIn'"></menu-view>

    </div>
    <div class="container-fluid" style="height: 100px; background: white;">
      <div class="row" style="padding-top:10px;padding-bottom: 50px;">
        <div class="col-8 text-left" style="font-size: x-small">
          <template v-if="merchantItem.registeredTitle != undefined && merchantItem.registeredTitle != null && merchantItem.registeredTitle.length > 0"><strong>{{merchantItem.registeredTitle}}</strong><br>trade as </template><strong>{{merchantItem.title}}</strong><br>{{merchantItem.contact}}<br><span v-html="merchantItem.addressText"></span>
          <span>{{merchantItem.address}}</span>
        </div>
        <div class="col-4">
          <img v-if="merchantItem.webSetting !== undefined && merchantItem.webSetting !== null && merchantItem.webSetting.icon !== null && merchantItem.webSetting.icon.length > 0" :src="merchantItem.webSetting.icon" height="60px;">
        </div>


        <div class="col-12" style="font-size:  x-small">
          Copyright @2021 <strong>{{merchantItem.title}}</strong>. All rights reserved
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getMerchant, submitLog} from "../api/borium";
  import EventBus from "../api/event-bus";

  import MenuView from "./MenuView";
  import Bottom from "./Bottom";
    export default {
      name: "Menus",
      data() {
        return {
          merchantItem:false,
        }
      },
      components: {
        MenuView,
        Bottom
      },
      created() {
      },
      mounted() {
        this.getMerchantItem();
      },
      beforeDestroy() {
      },
      destroyed() {
      },
      methods: {
        getMerchantItem: function() {
          // console.log(this.$route.params);
          let id = 0;
          if(this.$route.params.hasOwnProperty('id')) {
            id = this.$route.params.id;
          }
          // let url = 'https://' + window.location.host;
          // if(window.location.host.startsWith('localhost')) {
          //   url = 'http://' + window.location.host;
          // }
          let self = this;
          getMerchant(id)
            .then(function(data) {
              // console.log(data);
              if(data.success) {
                self.$data.merchantItem = data.item;
                self.setMerchant();
              }
            })
            .catch(function(err) {
              // console.log(err);
            })

        },
        setMerchant: function() {
          EventBus.$emit("setTitle", this.$data.merchantItem.title);
          this.$data.images = this.$data.merchantItem.imageUrl.split(',');

          if(this.$data.merchantItem.webDelivery == 0) {
            this.$data.mainMenus[1].enabled = false;
          }
          if(this.$data.merchantItem.webTable == 0) {
            this.$data.mainMenus[2].enabled = false;
          }
          if(this.$data.merchantItem.webOrder == 0) {
            this.$data.mainMenus[0].enabled = false;
          }
          if(this.$data.merchantItem.openingTime != null && this.$data.merchantItem.openingTime.length > 3) {
            this.$data.openingTime = JSON.parse(this.$data.merchantItem.openingTime);
          }
          // console.log(this.$data.merchantItem.deliveryTime);
          if(this.$data.merchantItem.deliveryTime != null && this.$data.merchantItem.deliveryTime.length > 3) {

            this.$data.deliveryTime = JSON.parse(this.$data.merchantItem.deliveryTime);
          }

          this.setPageMeta();
          submitLog(this.$data.merchantItem.merchantId, 'MenuPage', "")
            .then(function(data) {

            })
            .catch(function(err){

            })
        },
        setPageMeta: function() {
          const titleEl = document.querySelector('head title');
          const descEl = document.querySelector('head meta[name="description"]');
          const keywordsEl = document.querySelector('head meta[name="keywords"]');

          let title =this.$data.merchantItem.title;
          let key = this.$data.merchantItem.title;

          let description = "Simple click and collect & Takeaway and delivery order for " + this.$data.merchantItem.title;
          if(this.$data.merchantItem.region !== undefined && this.$data.merchantItem.region != null && this.$data.merchantItem.region.length > 0) {
            title += " in " + this.$data.merchantItem.region;
            key += "," + this.$data.merchantItem.region;
            description += " in " + this.$data.merchantItem.region;
          }
          key += ", takeaway, delivery";
          if(this.$data.merchantItem.tags !== undefined && this.$data.merchantItem.tags != null && this.$data.merchantItem.tags.length > 0) {
            key += "," + this.$data.merchantItem.tags;
          }
          title += " Takeaway | Delivery | Menu | Price | Show Me The Menu";
          titleEl.textContent = title;

          descEl.setAttribute('content', description);
          keywordsEl.setAttribute('content', key);

          if(this.$data.merchantItem.webSetting !== undefined
            && this.$data.merchantItem.webSetting != null
            && this.$data.merchantItem.webSetting.icon != null
            && this.$data.merchantItem.webSetting.icon.startsWith("https://")) {
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
              link = document.createElement('link');
              link.rel = 'icon';
              document.getElementsByTagName('head')[0].appendChild(link);
            }
            link.href = this.$data.merchantItem.webSetting.icon;
          }
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Menus.vue